<ng-container *ngTemplateOutlet="template; context: context"></ng-container>
